import React from 'react'
import { useAuth0 } from '/src/context/react-auth0-spa'

export default function DashboardStationHeader({ station, data }) {
  let lastDownload = 'Last download:'
  if (data && data.hourlyData.length !== 0) {
    const dd = data.hourlyData.slice(-1)[0]
    if (dd.date) {
      lastDownload = `Last download: ${dd.date.toLocaleDateString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hours12: true,
      })}`
    }
  }

  // use auth user
  const { user, isAuthenticated } = useAuth0();
  const isLoggedIn = isAuthenticated && user;

  return (
    <div
      className={`border-gray-50 rounded-lg items-center justify-between sm:flex sm:flex-row px-4 sm:py-6 bg-white py-4 sm:h-32 shadow-lg border-t-2 mt-8 md:mt-12`}
      data-e2e-mask="true"
    >
      <div>
        <h1 className="py-2 mb-0 leading-7 text-center text-gray-500 sm:leading-9 md:text-left md:mr-auto sm:py-1 sm:mb-2">
          <span className="hidden mb-2 text-2xl sm:inline-block sm:mr-1 sm:mb-0 sm:text-3xl">
            Results for
          </span>
          {station && (
            <span className="block text-xl font-semibold text-gray-900 sm:inline-block sm:text-3xl">
              {station.name}, {station.state}
            </span>
          )}
        </h1>

        <div className="mb-2 text-sm font-semibold text-center text-gray-600 sm:text-left">
          Courtesy of
          {station.affiliationUrl.length !== 0 ? (
            <a
              href={station.affiliationUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="ml-1"
            >
              {station.affiliation}
            </a>
          ) : (
            <span> {station.affiliation}</span>
          )}
        </div>

        <div className="mb-1 text-sm font-bold text-center text-gray-500 sm:text-left sm:mb-0">
          {lastDownload}
        </div>
      </div>

      {station && (
        <div
          className="items-center hidden w-40 mx-auto mt-2 text-sm leading-5 text-gray-600 sm:block sm:mt-0 sm:mx-0 sm:flex-col">
          <div className="flex-1 mb-1 text-center">
            <span className="font-semibold">Latitude:</span>{' '}
            <span className="">
              {station.lat ? station.lat.toFixed(2) : ''}
            </span>
          </div>
          <div className="flex-1 mb-1 text-center">
            <span className="font-semibold">Longitude:</span>{' '}
            <span className="ml-0">
              {station.lon ? station.lon.toFixed(2) : ''}
            </span>
          </div>
          <div className="flex-1 mb-1 text-center">
            <span className="font-semibold">Elevation:</span>{' '}
            <span className="ml-0">
              {station.elev ? `${station.elev} ft` : ''}
            </span>
          </div>
          {
            isLoggedIn &&
            <div className="flex-1 mb-1 text-center">
              <span className="font-semibold">Station ID:</span>{' '}
              <span className="ml-0">
                  {station.id ? station.id : ''}
                </span>
            </div>
          }
        </div>
      )}
    </div>
  )
}
